/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetTimesheetProjectsQueryResponse,
  GetTimesheetProjectsQueryParams,
} from '../models/GetTimesheetProjects.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getTimesheetProjectsQueryResponseSchema } from '../zod/getTimesheetProjectsSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getTimesheetProjectsQueryKey = (
  params?: GetTimesheetProjectsQueryParams,
) => [{ url: '/api/entries/projects' }, ...(params ? [params] : [])] as const;

export type GetTimesheetProjectsQueryKey = ReturnType<
  typeof getTimesheetProjectsQueryKey
>;

/**
 * {@link /api/entries/projects}
 */
export async function getTimesheetProjects(
  params?: GetTimesheetProjectsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetTimesheetProjectsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/entries/projects`,
    params,
    ...requestConfig,
  });
  return getTimesheetProjectsQueryResponseSchema.parse(res.data);
}

export function getTimesheetProjectsQueryOptions(
  params?: GetTimesheetProjectsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getTimesheetProjectsQueryKey(params);
  return queryOptions<
    GetTimesheetProjectsQueryResponse,
    ResponseErrorConfig<Error>,
    GetTimesheetProjectsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getTimesheetProjects(params, config);
    },
  });
}

/**
 * {@link /api/entries/projects}
 */
export function useGetTimesheetProjects<
  TData = GetTimesheetProjectsQueryResponse,
  TQueryData = GetTimesheetProjectsQueryResponse,
  TQueryKey extends QueryKey = GetTimesheetProjectsQueryKey,
>(
  params?: GetTimesheetProjectsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetTimesheetProjectsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getTimesheetProjectsQueryKey(params);

  const query = useQuery(
    {
      ...getTimesheetProjectsQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
